<footer
  rds-footer
  [appStoryblok]="_editable()"
  class="c-white bg-600-roche-blue"
>

<!--  commented as part of this story https://globaljira.roche.com/browse/INEXP-2134-->
<!--  <rds-footer-sitemap>-->
<!--    @for(section of categorySections(); track $index) {-->
<!--    <rds-footer-sitemap-section>-->
<!--      @for(c of section; track c) {-->
<!--      <rds-footer-link-->
<!--        [routerLink]="c"-->
<!--        [attr.aria-label]="c"-->
<!--        (click)="navigate(c)"-->
<!--        (keydown.enter)="navigate(c)"-->
<!--      >-->
<!--        {{ c }}-->
<!--      </rds-footer-link>-->
<!--      }-->
<!--    </rds-footer-sitemap-section>-->
<!--    }-->
<!--  </rds-footer-sitemap>-->

  @if(navigation()) {
  <rds-footer-navigation>
    @for(item of navigation(); track $index) {
    <rds-footer-link>
      @if(item.isExternal) {
      <a
        rds-link
        standalone
        [href]="item.link"
        [attr.aria-label]="item.title"
        target="_blank"
        rel="noopener noreferrer"
        class="c-white"
        size="m"
      >{{ item.title }}</a>
      } @else {
      <a
        standalone
        rds-link
        [routerLink]="item.link"
        [attr.aria-label]="item.title"
        class="c-white"
        size="m"
      >{{ item.title }}</a>
      }
    </rds-footer-link>
    }
  </rds-footer-navigation>
  } @if(disclaimer()) {
  <rds-footer-disclaimer [appStoryblok]="_editable()">
    <rds-footer-caption class="c-white">
      {{ disclaimer() }}
    </rds-footer-caption>
  </rds-footer-disclaimer>
  }
</footer>
